"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserId = getUserId;
exports.normalizeUserSettingsResponse = normalizeUserSettingsResponse;
exports.fetchUserSetting = fetchUserSetting;
exports.saveUserSetting = saveUserSetting;
exports.USER_SETTINGS_BULK_GET_API = exports.USER_SETTINGS_API = void 0;

var _immutable = require("immutable");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _UserSettingsSerialization = require("crm_data/settings/UserSettingsSerialization");

var USER_SETTINGS_API = 'users/v1/app/attributes';
exports.USER_SETTINGS_API = USER_SETTINGS_API;
var USER_SETTINGS_BULK_GET_API = 'users/v1/app/attributes/bulk-get';
exports.USER_SETTINGS_BULK_GET_API = USER_SETTINGS_BULK_GET_API;

function getUserId() {
  return _user.default.then(function (user) {
    return user.get('user_id');
  });
}

function normalizeUserSettingsResponse(rawSettings) {
  return rawSettings.attributes.reduce(function (acc, setting) {
    return Object.prototype.hasOwnProperty.call(setting, 'key') && Object.prototype.hasOwnProperty.call(setting, 'value') ? acc.set(setting.key, (0, _UserSettingsSerialization.decodeSettingsValue)(setting.value)) : acc;
  }, (0, _immutable.Map)());
}

function fetchUserSetting(keys) {
  return getUserId().then(function (userId) {
    return (0, _ImmutableAPI.put)(USER_SETTINGS_BULK_GET_API, {
      keys: keys.toArray(),
      user_id: userId
    }, normalizeUserSettingsResponse);
  });
}

function saveUserSetting(key, value) {
  return getUserId().then(function (userId) {
    var uriKey = encodeURIComponent(key);
    var uriUserId = encodeURIComponent(userId);

    try {
      var encodedValue = (0, _UserSettingsSerialization.encodeSettingsValue)(value);
      return (0, _ImmutableAPI.post)(USER_SETTINGS_API + "?key=" + uriKey + "&user_id=" + uriUserId, {
        key: key,
        value: encodedValue
      });
    } catch (error) {
      return Promise.reject(error);
    }
  });
}